/* ==============================================================================================
 * [ACCESS] CORPORATE ACTION SEARCH RESULTS TABLE
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	var apiEndpoint = "/json/access/corporateActionSearchResults.json";
	var tableElement = document.querySelector("#corporateActionSearchResultsTable");

	if (!tableElement) {
		return;
	}

	CGS.table(tableElement, {
		ajax: apiEndpoint,
		columns: [
			{
				data: "oldCusip",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "issuerName",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "newCusip",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "newIssuerName",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "corporateAction",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "effectiveDate",
				className: "c-table__cell",
				searchable: true,
			},
		],
		columnDefs: [
			{
				targets: [0, 2],
				render: function (data) {
					var content = document.createElement("a");

					content.setAttribute("data-plugin", "CorporateActionDetail");
					content.setAttribute("href", "#");
					content.setAttribute("data-cusip-number", data);
					content.innerHTML = data;

					return content.outerHTML;
				},
			},
		],
		initComplete: CGS.createRetractTableWrapper,
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
